import React from 'react';
import withRouter from '../../Components/Common/withRouter';

const NonAuthLayout = ({ children }: any) => {
    return (
        <React.Fragment>
            {children}
        </React.Fragment>
    );
};

export default withRouter(NonAuthLayout);